var ko = require('knockout');
var $ = require('jquery');
var find = require('lodash/find');
var get = require('lodash/get');
var pick = require('lodash/pick');
var debounce = require('lodash/debounce');
var cart = require('_components/organisms/shopping-cart/shopping-cart-storage');
var analytics = require('_js/analytics-ecommerce');
var APIHelper = require('_js/APIHelper');

require('knockout-postbox');
//Membershiptype 1 Person, 2 Agency, 3 no member

// A new topic which is (currently) used to detect when we add participants to a course
// to indicate that for these participants this course is overlapping with an already chosen course.
var UPDATE_PARTICIPANTS_TOPIC = 'updateParticipantsTopic';

function CheckoutOverviewPage(params) {
  var self = this;
  this.params = params;
  this.texts = params.texts;
  this.links = params.links;
  this.readonly = params.readonly || false;
  this.endpoints = params.endpoints;

  if (self.endpoints.employee === undefined) throw 'employee must be set';
  if (!this.readonly && this.links.paymentMethod === undefined)
    throw 'paymentMethod must be set';
  if (!this.readonly && this.links.summary === undefined)
    throw 'summary must be set';
  if (self.endpoints.prices === undefined) throw 'prices must be set';

  cart.resetOverlappingCoursesForParticipants();
  self.discounts = ko.observableArray([]);
  self.totalDiscounts = ko.observableArray([]);
  var currentUser = params.currentUser;
  self.chosenAgency = ko.observable();
  self.errorText = ko.observable('');
  var alreadyAddedUser = false;
  self.userHasAlreadyBoughtCourse = ko.observableArray([]);
  self.userHasAlreadyBoughtOnlineCourse = ko.observableArray([]);
  self.userHasAlreadyBoughtProgram = ko.observableArray([]);
  self.usersUnPublishedCourses = ko.observableArray([]);
  self.Total = ko.observable(0);
  self.totalPriceIncVat = ko.observable(0);
  self.totalFoodVat = ko.observable(0);
  self.totalAccommodationVat = ko.observable(0);
  self.totalOnlineCourseVat = ko.observable(0);
  self.acceptTermsForPrograms = ko.observable().extend({
    required: [
      {
        type: 'isCheckedOff',
        message: self.texts.requiredField
      }
    ]
  });

  self.summaryLink = this.links.summary;
  self.paymentMethodLink = this.links.paymentMethod;

  self.HasClickedOrderButton = false;

  self.employeeList = ko.observableArray([]);
  self.courseList = ko.observableArray([]);
  self.coursesSelected = ko.computed(function() {
    return self.chosenAgency() !== undefined && self.courseList().length > 0;
  });

  self.submitButtonDisabled = ko.computed(function() {
    return self.userHasAlreadyBoughtCourse().some(Boolean);
  });

  self.encodeCart = function() {
    // The cart model is a view model. It contains all of the data needed to render the cart.
    // The previous developers made the dubious choice to send the entire view model to the API when pressing the purchase button.
    // Since the view model contains html strings (aside from being a huge security risk) the API started crashing for some courses.
    // In order to solve the problem temporarily, this method now creates a new model based on the view model that only contains the data necessary to complete a purchase.
    // To solve this problem (and other potential ones) permanently, the entire localStorage-cart mess should be scrapped.

    var cartViewModel = cart.getCart() || {};
    var agency = pick(cartViewModel.agency, ['AktorId']);
    var payer = pick(cartViewModel.payer, [
      'AktorId',
      'ReferenceNo',
      'HideInLists'
    ]);
    var courses = get(cartViewModel, 'courses', []).map(function(course) {
      return pick(course, ['EventType', 'Key', 'participants']);
    });

    return JSON.stringify({
      agency: agency,
      payer: payer,
      courses: courses
    });
  };

  self.memberHasDiscount = function(course, participant) {
    for (var i = 0; i < self.discounts().length; i++) {
      if (
        (self.discounts()[i].SequenceId == course.Id ||
          self.discounts()[i].ProgramKey == course.Key) &&
        self.discounts()[i].ParticipantActorId == participant.AktorId
      ) {
        return self.discounts()[i].Discounts.length > 0;
      }
    }
    return false;
  };

  self.originalPrice = function(course, participant) {
    for (var i = 0; i < self.discounts().length; i++) {
      if (
        (self.discounts()[i].SequenceId == course.Id ||
          self.discounts()[i].ProgramKey == course.Key) &&
        self.discounts()[i].ParticipantActorId == participant.AktorId
      ) {
        return self.discounts()[i].OriginalPrice;
      }
    }
    return course.PriceNonMember;
  };

  function getPriceForParticipant(course, participant) {
    return (
      self.discounts().find(function(discount) {
        return (
          (discount.SequenceId === course.Id ||
            discount.ProgramKey === course.Key) &&
          discount.ParticipantActorId === participant.AktorId
        );
      }) || {}
    );
  }

  self.getPrice = function(course, participant) {
    return getPriceForParticipant(course, participant).ActualPrice;
  };

  var mapCourseList = function() {
    var courseList = self.courseList();
    var coursesWithParticipants = courseList.map(function(course) {
      var participants = course.participants.map(function(p) {
        return p.AktorId;
      });

      return {
        SequenceId: course.EventType == 6 ? course.Key.toString() : course.Id,
        ParticipantActorIds: participants,
        EmployerActorId: get(self.chosenAgency(), 'AktorId', ''),
        EventType: course.EventType,
        PayerActorId: self.readonly
          ? get(cart.getCart(), 'payer.AktorId', '')
          : ''
      };
    });
    return coursesWithParticipants;
  };

  self.showTermsForProgram = function() {
    return (
      self.readonly &&
      self.courseList().some(function(item) {
        return item.EventType == 6;
      })
    );
  };

  // This network call is expensive for the server. In some cases this endpoint is called excessively. It's debounced to avoid lag
  var getPrices = debounce(function() {
    var coursesWithParticipants = mapCourseList();

    APIHelper.QcPost(self.endpoints.prices, coursesWithParticipants, function(
      result
    ) {
      self.discounts(result.PricesAndDiscounts);
      self.Total(result.TotalPrice);
      self.totalDiscounts(result.TotalDiscounts);
      self.totalPriceIncVat(result.TotalPriceIncVat);
      self.totalFoodVat(result.TotalFoodVat);
      self.totalAccommodationVat(result.TotalAccommodationVat);
      self.totalOnlineCourseVat(result.TotalOnlineCourseVat);
    });
  }, 500);

  var previousCourseList = [];
  var trackAddToCart = function() {
    var courseList = self.courseList();
    courseList.forEach(function(course) {
      var previousCourse = find(previousCourseList, function(c) {
        return c.Key === course.Key;
      });

      if (!previousCourse) return;

      course.participants.forEach(function(participant) {
        // prettier-ignore
        var previousParticipant = find(
            previousCourse.participants,
            function(p) { return p.AktorId === participant.AktorId; }
          );

        if (!previousParticipant) {
          analytics.productAddedToCart(previousCourse, 1);
        }
      });
    });

    previousCourseList = courseList;
  };

  var showErrorMessage = function(length, message) {
    if (length === 0) {
      $('#common-error-message .error-message-text').html(message);
      $('#common-error-message').removeClass('hidden');
      return true;
    } else {
      return false;
    }
  };

  var hideErrorMessage = function(message) {
    var currentMessage = $('#common-error-message .error-message-text').html();
    if (message === currentMessage) {
      $('#common-error-message').addClass('hidden');
      return true;
    } else {
      return false;
    }
  };

  var canClickButton = function() {
    var courselist = self.courseList();
    if (showErrorMessage(courselist.length, window.language.missingCourses)) {
      return false;
    }

    for (var i = 0; i < courselist.length; i++) {
      if (
        showErrorMessage(
          courselist[i].participants.length,
          window.language.missingParticipants
        )
      ) {
        return false;
      }
    }
    return true;
  };

  self.goToPayment = function() {
    if (canClickButton()) {
      analytics.shoppingCartCheckedOut(
        2,
        cart.getCart(),
        self.paymentMethodLink
      );
    }
  };

  self.goToSummary = function() {
    if (canClickButton()) {
      analytics.shoppingCartCheckedOut(3, cart.getCart(), self.summaryLink);
    }
  };

  self.orderButton = function(data, e) {
    if (this.HasClickedOrderButton) {
      e.preventDefault();
      return false;
    }
    if (
      self.showTermsForProgram() &&
      self.acceptTermsForPrograms &&
      !self.acceptTermsForPrograms()
    ) {
      self.acceptTermsForPrograms.hasError(true);
      return false;
    }

    this.HasClickedOrderButton = true;
    return canClickButton();
  };

  var hasOverlappingSequencesInPackages = function() {
    APIHelper.QcPost(
      self.endpoints.overlappingSequencesCheck,
      mapCourseList(),
      function(response) {
        if (response) {
          showErrorMessage(0, self.texts.overlappingSequencesInPackages);
        } else {
          hideErrorMessage(self.texts.overlappingSequencesInPackages);
        }
      },
      function(err) {
        self.errorText(err.responseText);
      }
    );
  };

  ko.postbox.subscribe(
    cart.updateTopic,
    function(newCart) {
      self.courseList(newCart.courses);

      if (newCart.agency === undefined) {
        self.employeeList([currentUser]);
      } else if (newCart.agency.AktorId === '') {
        //When someone chose to not register agency
        self.employeeList([currentUser]);
      } else if (
        self.chosenAgency() === undefined ||
        newCart.agency.AktorId !== self.chosenAgency().AktorId
      ) {
        $.getJSON(
          self.endpoints.employee + '?agency=' + newCart.agency.Id, //AktorId,
          function(employees) {
            self.employeeList(employees);
          }
        );
      }

      self.chosenAgency(newCart.agency);
      trackAddToCart();
      getPrices();
      hasOverlappingSequencesInPackages();
    },
    true
  );

  var hasAlreadyBoughtCourse = function(index) {
    $.post(self.endpoints.usersHaveAlreadyBoughtCourse, {
      Users: [currentUser.AktorId],
      SequencePk: self.courseList()[index].Key
    })
      .success(function(data) {
        var hasBoughtCourse = data;
        if (hasBoughtCourse[currentUser.AktorId]) {
          self.userHasAlreadyBoughtCourse()[index] = true;
        } else {
          self.userHasAlreadyBoughtCourse()[index] = false;
          if (self.courseList()[index].EventType == 6) {
            cart.addParticipantToCourse(
              self.courseList()[index].Key,
              currentUser
            );
          } else {
            cart.addParticipantToCourse(
              self.courseList()[index].Id,
              currentUser
            );
          }
        }
        self.userHasAlreadyBoughtCourse.valueHasMutated();
      })
      .fail(function(err) {
        //TODO: add error message to template
        self.errorText(err.responseText);
      });
  };

  var hasAlreadyBoughtCourses = function() {
    self.userHasAlreadyBoughtCourse([]);
    if (
      self.chosenAgency() &&
      self.chosenAgency().AktorId === '' &&
      !alreadyAddedUser
    ) {
      alreadyAddedUser = true;
      for (var i = 0; i < self.courseList().length; i++) {
        hasAlreadyBoughtCourse(i);
      }
    } else {
      alreadyAddedUser = false;
    }
  };

  var hasAlreadyBoughtOnlineCourse = function(index) {
    $.post(self.endpoints.usersHaveAlreadyBoughtOnlineCourse, {
      Users: [currentUser.AktorId],
      SequencePk: self.courseList()[index].Key
    })
      .success(function(data) {
        var hasBoughtOnlineCourse = data;
        if (hasBoughtOnlineCourse[currentUser.AktorId]) {
          self.userHasAlreadyBoughtOnlineCourse()[index] = true;
        } else {
          self.userHasAlreadyBoughtOnlineCourse()[index] = false;
          cart.addParticipantToCourse(self.courseList()[index].Id, currentUser);
        }
        self.userHasAlreadyBoughtOnlineCourse.valueHasMutated();
      })
      .fail(function(err) {
        //TODO: add error message to template
        self.errorText(err.responseText);
      });
  };

  var hasAlreadyBoughtProgram = function(index) {
    $.post(self.endpoints.usersHaveAlreadyBoughtProgram, {
      Users: [currentUser.AktorId],
      ProgramKey: self.courseList()[index].Key
    })
      .success(function(data) {
        var hasBoughtProgram = data;
        if (hasBoughtProgram[currentUser.AktorId]) {
          self.userHasAlreadyBoughtProgram()[index] = true;
        } else {
          self.userHasAlreadyBoughtProgram()[index] = false;
          cart.addParticipantToCourse(self.courseList()[index].Id, currentUser);
        }
        self.userHasAlreadyBoughtProgram.valueHasMutated();
      })
      .fail(function(err) {
        //TODO: add error message to template
        self.errorText(err.responseText);
      });
  };

  var hasAlreadyBoughtPrograms = function() {
    self.userHasAlreadyBoughtProgram([]);
    if (self.chosenAgency() && self.chosenAgency().AktorId === '') {
      for (var i = 0; i < self.courseList().length; i++) {
        hasAlreadyBoughtProgram(i);
      }
    }
  };

  var hasAlreadyBoughtOnlineCourses = function() {
    self.userHasAlreadyBoughtOnlineCourse([]);
    if (self.chosenAgency() && self.chosenAgency().AktorId === '') {
      for (var i = 0; i < self.courseList().length; i++) {
        hasAlreadyBoughtOnlineCourse(i);
      }
    }
  };

  var hasAccessToCourses = function() {
    var sequenceKeys = [];
    for (var i = 0; i < self.courseList().length; i++) {
      var course = self.courseList()[i];
      if (course.EventType != 5 && course.EventType != 6) // exclude programs and packages
        sequenceKeys.push(course.Key);
    }
    if (sequenceKeys.length == 0) return;
    $.post(self.endpoints.getSequencesPublishedStatus, {
      SequenceKeys: sequenceKeys
    })
      .success(function(data) {
        Object.entries(data).forEach(function(entry) {
          var key = entry[0];
          var isPublished = entry[1];
          if (!isPublished) {
            var course = self.courseList().find(function(item) {
              return item.Key === parseInt(key);
            });
            self.usersUnPublishedCourses.push(course);
            self.removeCourse(course);
          }
        });
      })
      .fail(function(err) {
        //TODO: add error message to template
        self.errorText(err.responseText);
      });
  };

  ko.postbox.subscribe(
    'chosen_agency',
    function() {
      cart.resetOverlappingCoursesForParticipants(UPDATE_PARTICIPANTS_TOPIC);
      hasAlreadyBoughtCourses();
      hasAlreadyBoughtOnlineCourses();
      hasAlreadyBoughtPrograms();
      hasOverlappingSequencesInPackages();
    },
    true
  );

  self.hasAccessToCourses = function() {
    self.usersUnPublishedCourses([]);
    hasAccessToCourses();
  };

  self.removeCourse = function(course) {
    cart.removeOverlappingCoursesForParticipants(
      course.Id,
      course.participants,
      UPDATE_PARTICIPANTS_TOPIC
    );
    cart.removeCourseFromCart(course.Id);
    alreadyAddedUser = false;
    hasAlreadyBoughtCourses();
    hasAlreadyBoughtOnlineCourses();
    hasAlreadyBoughtPrograms();
    hasOverlappingSequencesInPackages();
  };

  self.removeParticipant = function(participant, course) {
    cart.removeOverlappingCoursesForParticipants(
      course.Id,
      [participant],
      UPDATE_PARTICIPANTS_TOPIC
    );
    cart.removeParticipantFromCourse(course.Id, participant.AktorId);
    hasOverlappingSequencesInPackages();
  };

  self.chosenAgency.subscribe(getPrices);
  self.hasAccessToCourses();
}

module.exports = CheckoutOverviewPage;
